import React, { useEffect, useRef } from 'react'

const DetailAuxiliaryDataWrapper = ({
  children,
  secondaryDataLoaderCallBack,
  secondaryCallbackArgs
}) => {
  const prevObjectIdRef = useRef()

  // tmp fix for saving auxiliary updates
  // work for part with objectId fix
  useEffect(() => {
    const currentId = secondaryCallbackArgs?._objectId

    if (Object.prototype.hasOwnProperty.call(secondaryCallbackArgs, '_objectId') && prevObjectIdRef.current !== currentId) {
      secondaryDataLoaderCallBack(secondaryCallbackArgs)
      prevObjectIdRef.current = currentId
    }
  }, [secondaryCallbackArgs])

  // work for parts without _objectIDs like `groups`
  useEffect(() => {
    if (!Object.prototype.hasOwnProperty.call(secondaryCallbackArgs, '_objectId')) {
      secondaryDataLoaderCallBack(secondaryCallbackArgs)
    }
  }, [])

  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        border: 0,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'space-between'
      }}
    >
      {children}
    </div>
  )
}

export default React.memo(DetailAuxiliaryDataWrapper)
